/* The security document, rendered from the file that is the source of truth.
 *
 * `docs/SECURITY.md` is what gets emailed to a customer, so it has to stay a
 * plain file that anyone can read, review in a diff and print. Rendering it
 * here rather than retyping it into JSX means the page and the file cannot
 * disagree -- which is the failure that makes a security document worse than
 * having none.
 *
 * WHAT IS DELIBERATELY NOT IMPORTED HERE
 *
 * `docs/OPERATIONS.md`. Caddy serves this bundle with `file_server` and no
 * authentication -- the login screen is a screen, not an access control, and
 * anyone can download the JavaScript. Anything imported with `?raw` is
 * therefore public. That is fine for a document written to be shared, and
 * disqualifying for the runbook, which names hosts, paths and procedures.
 * The check that this still holds is in docs/OPERATIONS.md itself.
 */
import security from '../../docs/SECURITY.md?raw'
import { Markdown } from '../md'
import { useT } from '../lang'

/* The document opens with its own `# Security`, which it needs as a file that
 * gets emailed and printed. This page renders that heading itself, translated,
 * so the copy in the body would be a second <h1> saying the same thing. Dropped
 * here rather than removed from the file: the file has to stand alone. */
const body = security.replace(/^#\s+.*\n/, '')

export function SecurityDoc() {
  const t = useT()
  return (
    <article className="doc-page">
      <header className="doc-head">
        <h1>{t('Security')}</h1>
        <p className="doc-lede">{t('Written to be shared. Print this page to send it.')}</p>
      </header>
      <Markdown source={body} />
    </article>
  )
}
